// export const VARIANTS_KEYS = {
//   alpha: 'alpha'
// } as const

export const DESKTOP_MAX_WIDTH = 1216
export const LAPTOP_MAX_WIDTH = 800
export const TABLET_MAX_WIDTH = 640
